import type { EligibilityCheckResponse } from '@features/patient-coverages';

export type EligibilityCheckState = NonNullable<
  EligibilityCheckResponse['eligibility_check_state']
>;

export const DEFAULT_ELIGIBILITY_CHECK_STATE: EligibilityCheckState = 'not_applicable';

type EligibilityCheckStateSource = Pick<
  Partial<EligibilityCheckResponse>,
  'eligibility_check_state'
>;

export function getEligibilityCheckState(
  data: EligibilityCheckStateSource | undefined,
): EligibilityCheckState {
  return data?.eligibility_check_state ?? DEFAULT_ELIGIBILITY_CHECK_STATE;
}

export function isEligibilityCheckDue(data: EligibilityCheckStateSource | undefined): boolean {
  return getEligibilityCheckState(data) === 'due';
}
